<template>
  <fragment>
    <div class="page-content" @touchmove.prevent @mousewheel.prevent v-if="isShow">
      <img class="end-url" :src="info.endImgUrl" alt="">
    </div>
  </fragment>
</template>

<script>
export default {
  name: 'EndBase',
  props: {
    info: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      isShow: false
    }
  },
  mounted() {
    let nowTime = new Date().getTime()
    this.isShow = this.info.endTimes - nowTime > 0 ? false : true
  },
}
</script>

<style lang="scss" scoped>
.page-content {
  z-index: 1000;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.8);
  .end-url {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
}
</style>